import { ChatResponse } from "./chat-response"

export const makeChatViewModel = (chat: ChatResponse): ChatViewModel => ({
  ...chat,
})

export type ChatViewModel = ChatResponse
